<div class="container">
    <div
        class="p-3"
        *ngIf="params.pendingData; else show"
    >
        <cmps-wait-status> </cmps-wait-status>
    </div>
    <ng-template #show>
        <div
            class="insight-backdrop-overlay"
            (click)="popUpService.hide()"
            *ngIf="popUpVisible"
        ></div>
        <div class="row">
            <div
                *ngIf="params.invalidUser"
                class="col-12"
            >
                <h6 class="alert alert-warning text-center">
                    The selected user is outside the hierarchy.
                </h6>
            </div>
            <div
                *ngIf="params.noData"
                class="col-12"
            >
                <h6 class="alert alert-warning text-center">
                    There is no data for the selected parameters.
                </h6>
            </div>
            <div
                *ngIf="params.invalidDate"
                class="col-12"
            >
                <h6 class="alert alert-warning text-center">
                    Please check the entered date.
                </h6>
            </div>

            <div class="col-12">
                <label>Name:&nbsp;</label>
                <span class="f-s-75-2">{{ params.user?.userName }}</span>
                <button
                    (click)="onSelectUser($event)"
                    class="green btn-mini"
                >
                    <cmps-icon svgIcon="pencil"></cmps-icon>
                </button>
            </div>

            <div class="mt-3 col-6">
                <div class="flex-form">
                    <label
                        class="mr-3 mb-0 min-25"
                        id="reportDate-label"
                    >
                        {{ i18n._965_DATE | translate }}
                    </label>

                    <div class="input-group">
                        <input
                            class="form-control"
                            [(ngModel)]="params.date"
                            (ngModelChange)="onSelectDate()"
                            [placeholder]="i18n._646_YYYY_MM_DD | translate"
                            aria-labelledby="reportDate-label"
                            ngbDatepicker
                            [minDate]="minDate"
                            [maxDate]="maxDate"
                            #dp="ngbDatepicker"
                        />
                        <div class="input-group-append">
                            <button
                                type="button"
                                class="btn btn-secondary cmps-cdk-py-0dot5"
                                aria-label="Toggle date picker"
                                [attr.aria-expanded]="dp.isOpen()"
                                (click)="dp.toggle()"
                            >
                                <cmps-icon svgIcon="calendar"></cmps-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-3 col-6">
                <div class="flex-form">
                    <label
                        class="mr-4 mb-0 min-25"
                        id="role-label"
                    >
                        {{ i18n._647_SELECT_A_ROLE | translate }}
                    </label>
                    <ng-select
                        aria-labelledby="role-label"
                        [options]="roles"
                        [(ngModel)]="params.role"
                        (ngModelChange)="onSelectRole()"
                        [disabled]="roleDisabled"
                        [placeholder]="&nbsp;"
                    >
                    </ng-select>
                </div>
            </div>

            <div class="mt-3 col-12">
                <ng-multiselect
                    [config]="{ placeholder: 'Search metrics', max: 6 }"
                    (change)="onSelectMetrics($event)"
                    [options]="metrics || []"
                    [value]="params.metrics"
                >
                </ng-multiselect>
            </div>

            <div class="mt-3 col-12">
                <button
                    class="btn btn-primary pull-right"
                    [disabled]="generateReportDisabled || params.pendingData"
                    type="button"
                    (click)="onGenerateReport()"
                >
                    <cmps-icon svgIcon="file-document"></cmps-icon>
                    Generate Report
                </button>
            </div>
        </div>
    </ng-template>
</div>
